export default "__VITE_ASSET__CTiRYaEe__"